import Vue from 'vue';
import Vuex from 'vuex';
import axios, { axiosM } from '@/plugins/axios';
import AccessModule from './views/access/access.store';

Vue.use(Vuex);
const store = new Vuex.Store<any>({
  state: {
    user: {
      username: '',
      治未病数据中心: false,
      中医影像数据中心: false,
      数据中心: {},
      分析挖掘: {},
      AI训练: {},
    },
    token: '',
    researchListComposeDiabled: true,
    cdrIfCompose: false,
    edrIfCompose: false,
    ossClient: {},
    moniAnswers: [],
    logoutTimer: 3 * 60 * 60
  },
  mutations: {
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    updateUser(state, data) {
      state.user = data;
    },
    updateResearchListComposeDiabled(state, ifDisable) {
      state.researchListComposeDiabled = ifDisable;
    },
    updateCdrIfCompose(state, ifCompose) {
      state.cdrIfCompose = ifCompose;
    },
    updateEdrIfCompose(state, ifCompose) {
      state.edrIfCompose = ifCompose;
    },
    updateOss(state, newOss) {
      state.ossClient = newOss;
    },
    updateMoniAnswers(state, answers) {
      state.moniAnswers = [].concat(answers);
    },
    updateLogoutTimer(state, timer) {
      state.logoutTimer = timer;
    }
  },
  actions: {
    async login({ commit, dispatch }, payload) {
      const { data } = await axios.post("api/user/login", payload);
      if (data.data) {
        commit('updateToken', data.data.token);
        // 返回dispatch保证login页面中能按顺序执行
        return dispatch('getUser');
      } else {
        return new Promise((resolve, reject) => {
          reject(data.msg);
        });
      }

    },
    async getUser({ commit }) {
      const { data } = await axios.get('api/user');
      commit('updateUser', data.data);
    },
  },
  modules: {
    access: AccessModule
  }
});

export default store;
